import { useRedux } from "hooks-for-redux";
import { editorType } from "../components/creator";

export const [usePlan, setPlan] = useRedux("plan", {name:'', _id:'', _rev:'', process:''})
export const [useOpenPlan, setOpenPlan] = useRedux("open", false)
export const [updatePlan, setUpdatePlan] = useRedux("updateplan", true)
export const [updateSOPs, setUpdateSOPs] = useRedux("updatesopss", true)
export const [updateProposals, setUpdateProposals] = useRedux("updateproposals", true)
export const [usePlans, setPlans] = useRedux("plans", [])
export const [useSelectedSOPs, setSelectedSOPs] = useRedux("selectedsops",[])
export const [useSOPs,setSOPs] = useRedux("sops", [])
export const [useFinalSOPs,setFinalSOPs] = useRedux("finalsops", [])
export const [useToEdit,setToEdit] = useRedux("toedit", {data:{}, doctype:''})
export const [useLastVersion, setLastVersion] = useRedux("lastversion", {})
export const [useToReview,setToReview] = useRedux("toreview", {})
export const [useAwaitingApproval,setAwaitingApproval] = useRedux("awaitingApproval", [])
export const [stepsCompleted, setStepsCompleted] = useRedux("stepscompleted",[false, false, false])
export const [creatorType, setCreatorType] = useRedux("creatortype", editorType.sop)
export const [useDocs, setDocs] = useRedux('docs', false)
export const [useProcesses, setProcesses] = useRedux('processes', [])
export const [useTags, setTags] = useRedux('tags', {
    AR:[],
    LOC:[],
    DOC:[],
    PR:[],
    ING:[],
    PRS:[], 
    EQU:[],
    PAC:[]
})
export const [useObjTags, setObjTags] = useRedux('objTags', {})